// Module
var code = "<div role=\"columnheader\">\n    <div role=\"button\" class=\"ui-grid-cell-contents u-flexEnd\">\n        <span class=\"ui-grid-header-cell-label\" ng-bind=\"grid.appScope.datatable.getAccountBalanceColumnHeader()\">\n        </span>\n    </div>\n</div>";
// Exports
module.exports = code;